import { makeStyles } from '@material-ui/core/styles';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';
import { Button, Dialog, DialogContent } from '@mui/material';
import Cookies from 'js-cookie';
import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getCartItems } from '../../../redux/actions/cartAction';
import { createOrder, getIndividualOrder, refreshCaptcha, verifyCaptchaAndUpdateOrder } from '../../../redux/actions/orderActions';
import { useCreatePaymentMutation } from '../../../redux/APIs/paymentApi';
import { selectUser } from '../../../redux/Slices/userSlice';
import OrderPlacedAnime from '../../layout/OrderPlacedAnime';
import CheckoutStepper from '../Checkout/subComponents/CheckoutStepper';
import PriceBreakup from '../Checkout/subComponents/PriceBreakup';
import './Payment.css';


const useStyles = makeStyles({
  dialogPaper: {
    borderRadius: '12px !important',
    width: '60vmax',
    height: '300px',
    maxWidth: '900px',
    maxHeight: '500px',
    transform: 'scale(1)',
    transition: 'transform 0.5s ease-in-out',
    boxShadow: 'none',
    backgroundColor: '#fff',
    padding: '0 !important',
    
  },
  
 
  '@media (max-width: 600px)': {
    dialogPaper: {
      // CSS styles specific to max-width 600px
      // For example:
      width: '90vw',
      height: '300px',
      maxWidth: 'none',
      maxHeight: 'none',
      padding: 0,
      margin: 0,
      margin: '0 !important', // Override margin
      maxHeight: '100% !important', // Override max-height
      borderRadius: '12px !important',
      
    },
  },
});

function Payment() {
  const classes = useStyles();
  // const { priceDetails } = useSelector((state) => state.cart);
  const user = useSelector(selectUser);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(localStorage.getItem('selectedPaymentMethod') || 'Debit/Credit Card');
  console.log('selectedPaymentMethod', selectedPaymentMethod);
  const [captchaModalOpen, setCaptchaModalOpen] = useState(false);
  const [captchaResponse, setCaptchaResponse] = useState(null);
  const [captchaCode, setCaptchaCode] = useState('');
  const [refreshCaptchaImage, setRefreshCaptchaImage] = useState('');
  const [captchaInput, setCaptchaInput] = useState('');
  const [orderId, setOrderId] = useState('');
  const [cashfreeResponse, setCashfreeResponse] = useState('');
  // const [id, setId] = useState('');
  const [orderConfirmationAnimationVisible, setOrderConfirmationAnimationVisible] = useState(false);
  const [createPayment] = useCreatePaymentMutation();
console.log(refreshCaptchaImage);

const dispatch = useDispatch();

  const handleInputChange = (e) => {
    setCaptchaInput(e.target.value);
  };
console.log(captchaInput)
  const isCaptchaValid = captchaInput.length >= 3 && !isNaN(captchaInput);
const id = '65340dad4fb23d466421aef4';
  const navigate = useNavigate();
  console.log(isCaptchaValid);
  console.log(id)
  const handleConfirmOrder = () => {
    if (isCaptchaValid) {
      // Perform the logic for confirming the order
      dispatch(verifyCaptchaAndUpdateOrder(orderId, captchaInput))
        .then((response) => {
          if (response.data && response.data.success) {
            console.log(response.data);
            setCaptchaModalOpen(false);
            // Show the order confirmation animation for 240ms
            showOrderConfirmationAnimation();
            setTimeout(() => {
              // After 240ms, navigate to the order status page
              navigate('/order-status');
              dispatch(getCartItems());

            }, 3500);
            dispatch(getIndividualOrder(id));
          }
        })
        .catch((error) => {
          // Handle error if necessary
          console.log('Failed to create order:', error);
        });
    }
  };
  
  const showOrderConfirmationAnimation = () => {
    // You can use a state variable to control the visibility of the animation component
    setOrderConfirmationAnimationVisible(true);
  
    const notificationSound = document.getElementById('notificationSound');
    notificationSound.volume = 0.5; // Adjust the volume (0 to 1)
    notificationSound.loop = false; // Set to true if you want the sound to loop
    notificationSound.play();
    // After 240ms, hide the animation
    setTimeout(() => {
      setOrderConfirmationAnimationVisible(false);
    }, 3500);
  };

  //Refresh Captcha Handler
  const handleRefreshCaptcha = async () => {
    dispatch(refreshCaptcha(orderId))
    .then((response) => {
      if (response.data && response.data.image) {
        setRefreshCaptchaImage(response.data.image)
      }
    })
    .catch((error) => {
      // Handle error if necessary
      console.log('Failed to refresh captcha:', error);
    });
  }

console.log({cashfreeResponse});
console.log(setCaptchaCode);
  useEffect(() => {
    const storedPaymentMethod = localStorage.getItem('selectedPaymentMethod');
    if (storedPaymentMethod) {
      setSelectedPaymentMethod(storedPaymentMethod);
    }
  }, []);

  const handlePaymentMethodSelection = (method) => {
    setSelectedPaymentMethod(method);
    localStorage.setItem('selectedPaymentMethod', method);
  };

  console.log(selectedPaymentMethod);
  const isContinueDisabled = !selectedPaymentMethod;

  const addressId = Cookies.get('spAdId');
  const paymentType = selectedPaymentMethod

  console.log(addressId);
  console.log(paymentType);
  const handleCreateOrder = () => {
    dispatch(createOrder(addressId, paymentType))
      .then((response) => {
        if (response.data && response.data.captcha) {
          // Set captchaModalOpen to true
          setCaptchaModalOpen(true);
          setCaptchaCode(response.data.captcha);
        }
        if(response.data && response.data.orderId){
          console.log(response.data)
          setOrderId(response.data.orderId)
          // setId(response.data._id)
        }
        // Set the response state variable
        setCaptchaResponse(response);
      })
      .catch((error) => {
        // Handle error if necessary
        console.log('Failed to create order:', error);
      });
      
  };

  console.log({user})

const handlePayment = async(paymentMethod) => {
  const response = await createPayment({
    userId: user?.id,
    productId: '676ae2a967b5f832825d1149',
    amount: 500,
    paymentMethod: paymentMethod
  })
  console.log('payment response', response)
  if(response?.data?.success){
    setCashfreeResponse(response?.data)
  }
}

  const closeCaptchModal = () => {
    setCaptchaModalOpen(false);
  }

  const upiApps = [
    { name: "Google Pay", logo: "https://img.icons8.com/?size=512&id=am4ltuIYDpQ5&format=png", url: cashfreeResponse?.paymentLinks?.gpay },
    { name: "PhonePe", logo: "https://img.icons8.com/?size=512&id=OYtBxIlJwMGA&format=png", url: cashfreeResponse?.paymentLinks?.phonepe },
    { name: "Paytm", logo: "https://img.icons8.com/?size=512&id=68067&format=png", url: cashfreeResponse?.paymentLinks?.paytm },
    { name: "BHIM", logo: "https://img.icons8.com/?size=512&id=5RcHTSNy4fbL&format=png", url: cashfreeResponse?.paymentLinks?.bhim },
  ];

  return (
    <Fragment>
      <div className="bg-slate-100 h-[100dvh] flex flex-col items-center sm:mt-[50px]">
        <div className="w-full sm:mt-[15px] max-sm:mt-11">
          <CheckoutStepper />
        </div>

        {selectedPaymentMethod === 'upi_intent' &&
        cashfreeResponse?.paymentLinks &&
        Object.keys(cashfreeResponse?.paymentLinks).length > 0 ? (
          <div className="relative w-full h-[100dvh] bg-white">
  {/* Glassmorphism Background */}
  <div className="absolute inset-0 z-0">
    <div className="absolute w-52 h-52 bg-pink-500 rounded-full opacity-40 blur-3xl max-sm:blur-2xl max-sm:opacity-80 top-16 left-1/4"></div>
    <div className="absolute w-72 h-72 bg-blue-500 rounded-full opacity-20 blur-2xl top-20 right-1/4"></div>
    <div className="absolute w-72 h-72 bg-cyan-500 rounded-full opacity-70 blur-3xl bottom-12 left-1/3"></div>
    <div className="absolute w-52 h-52 bg-violet-500 rounded-full opacity-70 blur-xl bottom-20 right-1/3"></div>
  </div>

  {/* UPI Payment Card */}
  <div className="relative z-10 w-96 h-[450px] mx-auto mt-8 bg-white/50 backdrop-blur-sm shadow-lg rounded-2xl border-white border-2">
    <div className="flex flex-col gap-3 items-start py-8 px-4">
      <span className="font-semibold text-lg text-gray-800">Pay with UPI</span>
      {upiApps.map((app) => (
        <a
        key={app.name}
        href={app.url}
        rel="noopener noreferrer"
        className="w-full p-3 bg-white backdrop-blur-sm flex items-center justify-between rounded-2xl text-black no-underline transition-all duration-300 relative group overflow-hidden"
      >
        {/* Gradient Border */}
        <div
          className="absolute inset-0 rounded-2xl bg-gradient-to-r from-pink-500 via-blue-500 to-cyan-500 opacity-45 p-[1.5px]"
          style={{
            zIndex: -1,
            mask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
            WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
            maskComposite: 'exclude',
            WebkitMaskComposite: 'xor',
          }}
        ></div>

        {/* Content */}
        <div className="flex items-center">
          <img src={app.logo} alt={app.name} className="h-8 w-8 mr-2" />
          <span className="text-gray-800">{app.name}</span>
        </div>
        <span className="text-neutral-500 text-xs py-2 px-3 rounded-full border border-neutral-200">Select</span>
      </a>
      ))}
    </div>
  </div>
</div>
        ) : (
          <div className="flex max-md:flex-col w-full h-full px-4 py-3 max-sm:mt-0 lg:max-w-[1200px]  lg:w-[1000px] xl:w-[1200px] lg:h-[600px] lg:justify-center gap-4 lg:px-24 lg:py-20 rounded-4 bg-white">
            <div className="md:flex-1">
              <span className="text-lg font-[600]">
                Select a Payment Method
              </span>
              <div
                className={`option_cont mb-4 mt-4 justify-between ${
                  selectedPaymentMethod === 'Debit/Credit Card'
                    ? 'selected'
                    : ''
                }`}
                onClick={() => {
                  handlePayment('card');
                  handlePaymentMethodSelection('Debit/Credit Card');
                }}
              >
                <div className='flex items-center'>
                <span className="payment_method_icons">
                  <img
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAACG0lEQVR4nO2Yv0tbURTHL3WwgzrZQsGCg1Jw0OSeINhFpIKTS8XFQf8EETp1sdCOdgioyTlGA90UcRb7FxTq2qFbB8XWJOe81BZLhyc38Ucgvrznj/a9vNwPnCEJId8P57z3bo5SFoul9UhtFJ9qkm2NUgYSNwqlTRaUnVTOeRZcArkYdnDwFOLiMBV6fEVMJ8IOC/615S8SoXECr66QOL4iYYcMWsqKUJN1xGKxtAgQgTsS2OdIDS3REXVHrAjZs5bE+xqBCJW6yIvl7piI8FgsRDSW5mMiIrmYiPCnWIgAyS+16D6Ig4ibyDj9TbkOAhIxWZ/njjvN6+Qav6zvCMpOBIK6jcosEU3WZNYZqbyH/KZOxOxWo74yTZyPEhCv1IrVYXarZi1pNnoR6oJjAl9KIGtA/lP9nL+qZgQqEnJwJcqnqlkYWP7eUb0meOWqE5f1reGXNclE2CMFgcaO3zUUATx5EnZI8Cvk3dG8+9C3pYD8I/SwVFt8CiT7gJJPIU9d+1T3GK+PIYY+rP4+p4FKs3pNoC/ttgcKXieC8v5fB67c5lE+a+IP5lieQhn3/MN0WwBl5v4C819A/gLIm5rkdTJbmhzKcK/6HwynC12auHDj0MhHGnkPSJYAS3Pm3n/rsbgvTKu9DpOa5LcZC0DZAOSFZJZfJNbLj1RUGVz9+Vgjv9LIGY38FlCmzblsesttCzubxWJRgTkDg3XIKZRflwcAAAAASUVORK5CYII="
                    alt="payment_cards"
                  />
                </span>
                <span>Pay with Debit/Credit Card</span>
                </div>
                <div className='flex items-center mr-8 gap-1'>
                  <span className='w-6 h-6'><img src='https://img.icons8.com/?size=512&id=13608&format=png' className='w-full h-full'/></span>
                  <span className='w-5 h-5'><img src='https://img.icons8.com/?size=100&id=Hv6kgDBSmQT1&format=png' className='w-full h-full'/></span>
                  <span className='w-6 h-6'><img src='https://img.icons8.com/?size=48&id=13610&format=png' className='w-full h-full'/></span>
                </div>
              </div>
              <div
                className={`option_cont mb-4 justify-between ${
                  selectedPaymentMethod === 'upi_intent' ? 'selected' : ''
                }`}
                onClick={() => {
                  handlePayment('upi_intent');
                  handlePaymentMethodSelection('upi_intent');
                }}
              >
                <div className='flex items-center'>
                <span className="payment_method_icons">
                  <img
                    src="https://img.icons8.com/?size=512&id=5RcHTSNy4fbL&format=png"
                    alt="upi_mayment"
                  />
                </span>
                <span>Pay with UPI</span>
                </div>
                <div className='flex items-center mr-8 gap-1'>
                  <span className='w-5 h-5'><img src='https://img.icons8.com/?size=96&id=am4ltuIYDpQ5&format=png' className='w-full h-full'/></span>
                  <span className='w-5 h-5'><img src='https://img.icons8.com/?size=96&id=OYtBxIlJwMGA&format=png' className='w-full h-full'/></span>
                  <span className='w-7 h-7'><img src='https://img.icons8.com/?size=48&id=68067&format=png' className='w-full h-full'/></span>
                </div>
                
              </div>
              <div
                className={`option_cont mb-4 ${
                  selectedPaymentMethod === 'net_banking' ? 'selected' : ''
                }`}
                onClick={() => {
                  handlePayment('net_banking');
                  handlePaymentMethodSelection('net_banking');
                }}
              >
                <span className="payment_method_icons">
                  <img
                  // src='https://img.icons8.com/?size=160&id=ZGNlUMHnRbvE&format=png'
                  src='https://img.icons8.com/?size=160&id=ZGNlUMHnRbvE&format=png'
                    // src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAA4klEQVR4nM2WTQ4CIQyFv5XeQq+nJzDqBbySP9dww8ITzOx1VVPDJOPYGWCAxJc0IfDoKw3QAqyBG/ACZGCOMJyxT31dgRXe+R5YUA4L4ABc8GolnXdYet+fI3VojeMK0GCjDXBlKNAfMzLvAnzJFZC/E3AVBdzUYoxAk3AhZgkkw4pIrKtXExJ4M66UgMzZbH1cMpKu7EhzgmrGyFtgZ9jGr98jRb/SN3xoJ8PE2DiVIulzUr4KieD+8FMEHrUFyBWIeckhbp8vtUvmUwda/bVAly76x67oa9uig9Jty1nbljcS7a32tARp2wAAAABJRU5ErkJggg=="
                    alt="upi_mayment"
                  />
                </span>
                <span>Net Banking</span>
                
              </div>
              <div
                className={`option_cont mb-4 ${
                  selectedPaymentMethod === 'cod' ? 'selected' : ''
                }`}
                onClick={() => handlePaymentMethodSelection('cod')}
              >
                <span className="payment_method_icons">
                  <img
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEaklEQVR4nO2XbUwbdRzH74UafeGCQIxuZHLAqCsbK5AIIUG0ZANWoLRLt3bYlqqDzlCmZhofNloe7IBdOzYo0CMCupUCYW4vNDyFdmP4gGRQkmoyHS823vjO6BI1xvkz/9PO612pbblu19hf8s31er1/P9/7PfxbDItHZFHsNj5U7bIUoyMWayFzt6fIXMS83G0BuZvox2IpKqfMZXI38cPf8BZKMhdRg/E9nhnSPrrj3OErqYQCAQPDwB3F3BkBxtfIttflp7RX/5RwQgxIog/r/QzIkQm3ZVXxheUxjG8htOlak037/vTBIz1xQgzFF99hm3AR3RifSkbQXbOAYBMC6MnmMqiYNrNMHHATqgfNjuWS+oJtp6Q/BwKnKzVAP8hdxI/yWWvaA4PP6tWak02lfiUTTDmD+kCltKQYNz5yX8Ezzhq2pHepPAknS0ICp/fDCxff9S+j+TNwcLFnUekhr6hWBp6LOrzIfqQw5ZT0Tjjgfv3QUg7lU60gnm6BQ9f7QLVK3pPSY78cVXhhb21HstF/yoQM3rYfBINHQDjeCGkX6gA/Xweyr8/5G1i1/67+tjuJc/A9Q9oEqmTChE5sLoUMUgvCUQOkXdBT0HQVzZj8DFAmrvfrOYXPJvWlW81Vv4Rc500lkN73EuwaM0C6gw2N04SywTKw3HeDM3ihrbY3ybiXtTElGff6Q58UA95zGHY5G2CH87Wg0DhDVV91MfqAvKtY6du2KfCCgVcScYvCS4fM6FLBi5+8B9Vzp6npUTnbDoUTb0P2qAEEow1hQeM0FU41sbKg8pBvRgy/x/6y5Glz5a//Pt0SKHC8fm/sVc51QNFkE+wcN0QMjdMkcDag5mUaWIoIfqdNPZDIKI/coaNQ4eqE5yeNsHviDcDP13MCjtMk+dzCysIhD5kZMnievS45lVB85zf2WstB+JEeci69xTkwzlDBZ++zm9lDGkOC302+Kn2qreI3auyZ9gUde0hZE8eoui2ebYGiaRPkXD4OaZvMSqbzKCg9/cxN7fv/hJfNWTSZZ2v+SO9XQ9ZYY9Cx9+xYQ8BUI8mWukF06fimTJRd62Ste3DVnhsQvGqh4/GKT80z0plOkLkJEDkaYXuvZkMJBuuhynUa5FetG0p21QI5I8eCrrM9iEQjjaw1pZMfoP8MD7MMqG8M39WtO4GuvIVmXkjH4FLf/HiRZYD5IT4b0K07IW4gb6EZ8r9sA8k3PaBaGwbtrRFKyrVhkHht1DVeZ0C8YgXtLUfAxZHQNfGylZ8GxCvWDcGZ4sKEjksDqDSCPXlWJm47Nl1OOi4NoJoPFd6n/d4e/hhQrg2HbQDdwxsDmjDKh97QvDGgjcTAbR4ZUMV6CUm8tthu4vwwx6iGb2M0D21ky9xtZBKvjfoJgo6BzqNiwGcCNWewJx/KLqz5J5u+ScU8j5oBXzmh+lbeHKK+GAm9Ru+FWjYSr426D22Qgc6jauB+Sfe/MFC77rwWOwZG5lkG4hGPeGAxGX8BGduAwJZsTtAAAAAASUVORK5CYII="
                    alt="cod_icon"
                  />
                </span>
                <span>Cash on Delivery</span>
              </div>
            </div>
            <div className="flex">
              <div className="md:w-[90%] w-full">
                <PriceBreakup selectedPaymentMethod={selectedPaymentMethod} />
              </div>
            </div>
          </div>
        )}
      </div>
      <Dialog
        onClose={closeCaptchModal}
        open={captchaModalOpen}
        classes={{
          paper: classes.dialogPaper,
        }}
        BackdropProps={{
          style: {
            backgroundColor: 'rgba(8, 8, 8, 0.541)',
            backdropFilter: 'blur(8px)',
          },
        }}
      >
        <div className="backBtn_signUp_popup clsBtn_signUp_popup"></div>
        <DialogContent>
          <div className="captcha_content_main">
            <span
              onClick={closeCaptchModal}
              className="captcha_modal_close_btn"
            >
              Close
            </span>
            <h4>Verify Captcha to Confirm Order</h4>
            <div>
              {refreshCaptchaImage ? (
                <img
                  src={`data:image/jpeg;base64,${refreshCaptchaImage}`}
                  alt="Captcha"
                />
              ) : (
                <img
                  src={`data:image/jpeg;base64,${captchaCode}`}
                  alt="Captcha"
                />
              )}
              <button
                onClick={handleRefreshCaptcha}
                className="refresh_captcha_btn"
              >
                <RefreshRoundedIcon style={{ color: 'blue' }} />
              </button>
            </div>
            <input
              type="number"
              placeholder="Enter the code shown above"
              value={captchaInput}
              onChange={handleInputChange}
            />
            <Button
              className="confirm_ordr_btn"
              disabled={!isCaptchaValid}
              onClick={handleConfirmOrder}
            >
              Confirm Order
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {orderConfirmationAnimationVisible && (
        <OrderPlacedAnime
          showOrderConfirmationAnimation={showOrderConfirmationAnimation}
        />
      )}
      {orderConfirmationAnimationVisible && (
        <audio id="notificationSound" src="OrdrNotify.mp3"></audio>
      )}
    </Fragment>
  );
}

export default Payment;
